//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import HowItWorks from '~/components/common/HowItWork.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import DescriptionBlock from '~/components/forCompanies/DescriptionBlock.vue'
import AnimatedLink from '~/components/common/AnimatedLink.vue'
import PaymentDescription from '~/components/common/PaymentDescription.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    HowItWorks,
    DescriptionBlock,
    AnimatedLink,
    PaymentDescription
  },
  head () {
    return {
      title: this.$t('footer.payment-methods.oxxo').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      hiw: {
        title: 'oxxo.block1.title',
        subtitle: 'oxxo.block1.text',
        steps: [
          'oxxo.block1.item1',
          'oxxo.block1.item2',
          'oxxo.block1.item3',
          'oxxo.block1.item4'
        ],
        imgs: [
          require('@/assets/img/payment-methods/oxxo/b1-1.png'),
          require('@/assets/img/payment-methods/oxxo/b1-2.png'),
          require('@/assets/img/payment-methods/oxxo/b1-3.png'),
          require('@/assets/img/payment-methods/oxxo/b1-4.png')
        ]
      }
    }
  }
}
